import {Injectable} from "@angular/core";
import {CoreApiService} from "../../core/service/core-api.service";
import {Observable} from "rxjs";
import {CustomerFormDto, FormDto, ScheduleDto} from "../../core/interfaces/core.types";
import {OnboardingDto, UserInsuranceDto} from "../types/ob.interfaces";
import {UserInteractionDto} from "../../ci/types/ds-interaction.types";
import {HttpContext, HttpHeaders} from "@angular/common/http";
import {IG_Token} from "../../core/auth/auth.interceptor";

@Injectable({ providedIn: 'root' })
export abstract class OnboardingService {

  endPoint: string = "mvseu/eu/onboarding"


  constructor(
    protected coreApiService: CoreApiService) {
  }


  public getOnboardingOnRegistration(token?: string) : Observable<OnboardingDto> {
    // let header = new HttpHeaders();
    // if(token){
    //   header = header.set('IgAuthorization', `Bearer ig_pass ${token}`);
    // }
      return this.coreApiService.getList(`${this.endPoint}/getOnboardingOnRegistration`,);
  }

  public startOnboardingOnRegistration() : Observable<OnboardingDto> {
    return this.coreApiService.get(`${this.endPoint}/startOnboardingOnRegistration`);
  }

  // old one we might not use this
  public updateQuestionnaireOnRegistrationRegular(dto: CustomerFormDto) : Observable<OnboardingDto> {
    return this.coreApiService.update(dto,`${this.endPoint}/updateQuestionnaireOnRegistrationRegular`);
  }

  public updateQuestionnaireOnRegistration(dto: FormDto) : Observable<OnboardingDto> {
    return this.coreApiService.update(dto,`${this.endPoint}/updateQuestionnaireOnRegistration`);
  }

  /*
  public scheduleAppointmentOnRegistration(dto: ScheduleDto) : Observable<OnboardingDto> {
    return this.coreApiService.post(dto,`${this.endPoint}/scheduleAppointmentOnRegistration`);
  }

  public storeScheduleTypeOnRegistration(dto: ScheduleDto) : Observable<OnboardingDto> {
    return this.coreApiService.post(dto,`${this.endPoint}/storeScheduleTypeOnRegistration`);
  }
  */

  /**
   * Changed approach (previously used scheduleAppointmentOnRegistration, storeScheduleTypeOnRegistration).
   * @param scheduleTypeId
   * @param freeSlotId
   */
  public finalizeOnboardingOnRegistration(scheduleTypeId: number | null, freeSlotId?: string | undefined) : Observable<OnboardingDto> {
    if (scheduleTypeId == null) {
      return this.coreApiService.post({}, `${this.endPoint}/finalizeOnboardingOnRegistration`);
    } else if (freeSlotId) {
      return this.coreApiService.post({}, `${this.endPoint}/finalizeOnboardingOnRegistration?scheduleTypeId=${scheduleTypeId}&freeSlotId=${freeSlotId}`);
    } else {
      return this.coreApiService.post({}, `${this.endPoint}/finalizeOnboardingOnRegistration?scheduleTypeId=${scheduleTypeId}`);
    }

  }

  public saveUserInsurance(dto: UserInsuranceDto) : Observable<UserInsuranceDto> {
    return this.coreApiService.post(dto,`/mvseu/eu/euUserInsurances`);
  }



}
